import React, { useState, useEffect } from 'react'
import dynamic from 'next/dynamic'
import CardInputComponent from '../../../../../common/componentsV2/visa/VisaDetails/index'
import VisaSuccessCard from '../../../../../common/componentsV2/visa/VisaSuccessCard/index'
import ExclusiveBenefits from '../../../PageBreakUp/ProMemberShip/Benefits'
const BreadCrumb = dynamic(() => import('@/../../../common/componentsV2/Activity/BreadCrumb'))
import BreadCrumbCss from '../../../../../common/componentsV2/Activity/BreadCrumb/themeCss/theme12.module.css'
import { useRouter } from 'next/router'
import styles from './index.module.css'
import { subscriptionOrderDetails } from '../../../../lib/subscriptionService'
import commonFunction from '../../../../lib/utils/common.js';


const Visa = (props) => {
  const [success, setSuccess] = useState(false);
  const [isActivePlan, setIsActivePlan] = useState(false);
  const [cardData, setCardData] = useState(null)
  const [pg_Url, setPG_Url] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const router = useRouter()
  const { confirmationId, order_id, page } = router.query;
  const currency = commonFunction.getCookieTocken("selectedCurrency") || 'INR';


  const getBookingDetails = async (id) => {
    const site_id = props?.pageInfo?.site?.id
    const access_token = props?.userToken || ''
    const order_token = id

    try {
      const res = await subscriptionOrderDetails({
        site_id,
        access_token,
        order_token,
        currency: currency
      })

      if (res?.status) {
        setCardData(res?.data?.data)
        setSuccess(true)
      }
    } catch (error) {
      console.error('Error occurred while fetching booking details', error)
    } 
      finally {
      setIsLoading(false)
    }

  }


  useEffect(() => {
    if (confirmationId) {
      getBookingDetails(confirmationId)
    }
    else {
    setIsLoading(false)
  }

    // const pgUrl = sessionStorage.getItem("PG_URL");
    // console.log("Retrieved PG_URL from sessionStorage:", pgUrl);
    // setPG_Url(pgUrl);
    // if (pgUrl) {
    //   // optional: remove after read
    //   // sessionStorage.removeItem("PG_URL");

    //   // window.location.href = pgUrl;
    // }  // for future use

  }, [confirmationId,])




  const { isMobile, visaCardStyle, visaDetailsStyle, mobileHeaderStyle } = props

  return (
    <div className={styles.visa_main_wrapper}>
      <div className={styles.visa_breadcrumb}>
        {!isMobile && success &&
          <BreadCrumb
            styles={BreadCrumbCss}
            link1={{
              name: "BB-Pass Membership",
              link: '/membership'
            }}
            link2={{
              name: "Visa Free Membership",
              link: `/visa/${confirmationId}`
            }}
          />}
      </div>
      <div className={styles.visa_container}>
        {isLoading ? null : success ? (
          <>

            <VisaSuccessCard
              styles={visaCardStyle}
              mobileHeaderStyle={mobileHeaderStyle}
              setSuccess={setSuccess}
              cardData={cardData}
              isMobile={isMobile}
              isActivePlan={isActivePlan}
              setIsActivePlan={setIsActivePlan}
              {...props}
            />
          </>
        ) : (
          <>
            <div className={styles.member_header}>
              <div className={styles.visa_logo}>
                <img src='/images/visa_logo.svg' alt='visa_logo' />
              </div>
              <p className={styles.member_description}>Enjoy free membership with your Visa card and exclusive discounts on top attractions.</p>
            </div>
            <CardInputComponent
              styles={visaDetailsStyle}
              redirectPath="/membership"
              isMobile={isMobile}
              mobileHeaderStyle={mobileHeaderStyle}
              onSuccess={() => {
                setSuccess(true)
              }}
              router={router}
              setCardData={setCardData}
              setSuccess={setSuccess}
              pg_Url={pg_Url}
              {...props}
            />
          </>

        )}
      </div>
      {success &&
        (isMobile ? (
          <div className={window.location.pathname === '/visa' ? styles.exclusive_benefits_visa : styles.exclusive_benefits_membership}>
            <ExclusiveBenefits isVisa={true} isMobile={isMobile} {...props} benefits={cardData?.plan_benefits} />
          </div>
        ) : ((!confirmationId && !order_id) &&
          <div className={window.location.pathname === '/visa' ? styles.exclusive_benefits_visa : styles.exclusive_benefits_membership}>
            <ExclusiveBenefits isActivePlan={isActivePlan} isVisa={true} isMobile={isMobile} {...props} benefits={cardData?.plan_benefits} />
          </div>
        ))}

    </div>
  )
}

export default Visa
